// extracted by mini-css-extract-plugin
module.exports = {"consentsButtonContainer":"ConsentsSubmitButton_consentsButtonContainer__1PnBL"};